import { ActionReducerMap } from '@ngrx/store';

import { authReducer } from './+state/authentication/auth.reducer';
import { authWebEffects } from './+state/authentication/auth.effects';

// Shared reducers
export const webSharedReducers: ActionReducerMap<unknown> = {
  authWeb: authReducer,
};

// Shared effects
export const webSharedEffects = [authWebEffects];

// Shared actions
export {
  LoadFederatedLoginWeb,
  LoadFederatedLoginWebSuccess,
  LoadFederatedLoginWebFail,
} from './+state/authentication/auth.actions';

// Shared selectors
export { getFederatedLoginDataActionState } from './+state/authentication/auth.selectors';

// Services
export { AuthWebService } from './services/authentication/auth.service';
export { AuthTokenWebService } from './services/authentication/auth-token.service';
export { KeycloakService } from './services/authentication/keycloak.service';
export { initializeKeycloak } from './services/authentication/initialize-keycloak-service';
export { initializeCustomerIdent } from './services/authentication/initialize-customer-ident';

export { showBackendErrorToast } from './services/errors/backend-error-toast';

export { LocalStorageService } from './services/storage/local-storage.service';
export { SessionStorageService } from './services/storage/session-storage.service';
export { StorageWebService } from './services/storage/storage.service';

// Guards
export { welcomePageGuard } from './guards/welcome-page.guard';
export { onboardingPageGuard } from './guards/onboarding-page.guard';

// Interceptors

export { authWebInterceptor } from './interceptors/auth-web.interceptor';

// injection tokens
export { INFRASTRUCTURE_CONFIG, infrastructureConfig } from './injection-tokens/infrastructure';
